// extracted by mini-css-extract-plugin
export var currencyInput = "_my-1";
export var currencySymbol = "_my-0";